<template>
<div>
    <h1 v-if="isLoading">{{ $t('PACKS.LOADING') }}</h1>
    <div v-else class="padded">
        <h1>{{ privacyPolicy?.title }}</h1>
        <div v-md="privacyPolicy?.content" />
    </div>
</div>
</template>

<script lang="ts">
import type { JBGWeb } from '$types/JBGWeb'

export default defineNuxtComponent({
    fetchKey() {
        const { $i18n } = useNuxtApp()
        return `privacy-policy-${$i18n.locale.value}`
    },
    data() {
        return {
            isLoading: true,
            privacyPolicy: <JBGWeb.PrivacyPolicy | null> null
        }
    },
    async asyncData({ $cms, $i18n, $getParams }) {
        const data = {}

        try {
            const { locale: localizedSlugSuffix = '' } = $getParams()
            const privacyPolicy = await $cms.fetchOne<JBGWeb.PrivacyPolicy>('privacy-policy', `privacy-policy${localizedSlugSuffix}`, {
                locale: $i18n.locale.value
            })
            data.privacyPolicy = privacyPolicy
            data.isLoading = false
        } catch (error) {
            console.error('Failed to load Privacy Policy content:', error.message)
            // void router.push({ name: 'notFound' })
        }

        return data
    },
    head({ $i18n }) {
        return {
            title: `${$i18n.t('FOOTER.PRIVACY_POLICY')}`,
            meta: [
                {
                    name: 'description',
                    content: this.privacyPolicy?.seo?.metaDescription
                }
            ],
            link: [
                {
                    rel: 'canonical',
                    href: 'https://www.jackboxgames.com/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'x-default',
                    href: 'https://www.jackboxgames.com/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'en',
                    href: 'https://www.jackboxgames.com/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'fr',
                    href: 'https://www.jackboxgames.com/fr/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'it',
                    href: 'https://www.jackboxgames.com/it/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'de',
                    href: 'https://www.jackboxgames.com/de/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'es-ES',
                    href: 'https://www.jackboxgames.com/es/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'es',
                    href: 'https://www.jackboxgames.com/es/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'es-MX',
                    href: 'https://www.jackboxgames.com/es-XL/privacy-policy'
                },
                {
                    rel: 'alternate',
                    hreflang: 'pt-BR',
                    href: 'https://www.jackboxgames.com/pt-BR/privacy-policy'
                }
            ]
        }
    }
})
</script>
